import React, { useContext, useState } from 'react';
import './createSurvey.css';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../../components/navbar/Footer';
import useFetch from '../../hooks/useFetch';
import { StepsContext } from '../../context/stepsContext';
import Navbar from '../../components/navbar/Navbar';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../config';
import { MD5 } from 'crypto-js';
export default function DoSurvey({ minutesDisplay, secondsDisplay, setStart }) {
  const { survey_id } = useParams();
  const [personType, setPersonType] = useState({ id: '', type: '' });
  let param =
    survey_id === REACT_APP_SURVEY_ID_ER
      ? survey_id
      : `${survey_id}/${personType.type}`;
  const { data, loading } = useFetch(
    `${process.env.REACT_APP_BASE_URL}/survey/getSurveyDetails/${param}`
  );
  // console.log('mddd', REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER);
  // console.log('mddd', MD5(2600)?.toString());
  // console.log('mddd', MD5('2100')?.toString());
  // console.log('mddd', MD5('2600')?.toString());
  // console.log(
  //   'mddd',
  //   MD5('2600')?.toString() === '32b991e5d77ad140559ffb95522992d0'
  // );
  const navigate = useNavigate();
  const { dispatch } = useContext(StepsContext);
  const handleClickNav = async () => {
    setStart(true);
    dispatch({ type: 'START' });
    navigate('/stepone', {
      state: {
        state: data,
        survey_id: MD5(data?.project_id)?.toString(),
        personType: personType.type,
        loading: loading,
      },
    });
  };
  const survey_id_manage =
    survey_id === REACT_APP_SURVEY_ID
      ? REACT_APP_SURVEY_ID
      : REACT_APP_SURVEY_ID_ER;
  console.log(survey_id === REACT_APP_SURVEY_ID);
  console.log(survey_id);
  console.log(REACT_APP_SURVEY_ID);
  console.log(REACT_APP_SURVEY_ID_ER);
  console.log(survey_id_manage);
  const [accept, setAccept] = useState(false);
  return (
    <div className="create-container">
      <Navbar
        special={survey_id_manage === survey_id}
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
      />
      <div
        className="create-banner"
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + '/assets/images/peoples.png'
          })`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100%',
        }}
      >
        <div className="main-create-container">
          <div className="create-main xs:!w-11/12">
            <div className="create-main-header">
              {survey_id === REACT_APP_SURVEY_ID_ER
                ? 'Your Voice'
                : 'Your wellbeing voice.'}
            </div>

            <div
              className="create-main-text text-xl"
              style={{ width: '100%', textAlign: 'center' }}
            >
              <h3>
                {survey_id === REACT_APP_SURVEY_ID_ER
                  ? 'Welcome to the KAYA Survey. This survey is your opportunity to anonymously tell how you are feeling about work and the support you receive from work.'
                  : 'Welcome to the KAYA Wellbeing Survey. This survey is your opportunity to anonymously tell how you are feeling about work and the support you receive from work to manage your wellbeing.'}
              </h3>
            </div>
            <div
              className="create-main-text text-xl"
              style={{ width: '100%', textAlign: 'center' }}
            >
              <h3>The survey will take few minutes to complete.</h3>
            </div>
            <div className="create-main-small">
              Please tell us what's working and what isn't. We will not share
              your data with anyone. It will be anonymised and aggregated to
              help form a bigger picture of wellbeing issues in the UK.
            </div>
            {survey_id_manage === survey_id && (
              <Box className="flex items-center">
                <Checkbox
                  sx={{
                    '&.Mui-checked': {
                      color: '#fff',
                    },
                    color: 'white',
                  }}
                  checked={accept}
                  onChange={(e) => setAccept(e.target.checked)}
                />
                <Typography className="xs:!text-sm sm:!text-lg md:!text-2l">
                  {' '}
                  Accept{' '}
                  <a
                    href={`${process.env.REACT_APP_BASE_URL_TOS}/assets/PLATFORM_TOS.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline' }}
                  >
                    Terms of Services
                  </a>{' '}
                  and{' '}
                  <a
                    href={`${process.env.REACT_APP_BASE_URL_TOS}/assets/Privacy-policy-Survey.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline' }}
                  >
                    Privacy Policy
                  </a>
                </Typography>
              </Box>
            )}
            {!(survey_id === REACT_APP_SURVEY_ID_ER) && (
              <Stack flexDirection={'row'} alignItems={'center'} gap={'20px'}>
                <Typography fontWeight={600} fontSize={'20px'}>
                  I am
                </Typography>

                <FormGroup
                  sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className="mb-4 w-max flex self-end"
                    style={{
                      backgroundColor:
                        personType.id === 1 ? '#2691a3' : '#D0ECE6',
                      color: personType.id === 1 ? '#fff' : '#000',
                    }}
                    sx={{
                      fontSize: '16px',
                      fontWeight: 500,
                      padding: '8px 30px',
                      textTransform: 'capitalize',
                      color: personType.id === 1 ? '#fff' : '#000',
                      backgroundColor:
                        personType.id === 1 ? '#2691a3' : '#D0ECE6',
                      '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                        backgroundColor:
                          personType.id === 1 ? '#2691a3' : '#D0ECE6',
                      },
                    }}
                    onClick={() => setPersonType({ id: 1, type: 'employee' })}
                  >
                    An employee
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className="mb-4 w-max flex self-end"
                    style={{
                      backgroundColor:
                        personType.id === 2 ? '#2691a3' : '#D0ECE6',
                      color: personType.id === 2 ? '#fff' : '#000',
                    }}
                    sx={{
                      fontSize: '16px',
                      fontWeight: 500,
                      padding: '8px 30px',
                      textTransform: 'capitalize',
                      color: personType.id === 2 ? '#fff' : '#000',
                      backgroundColor:
                        personType.id === 2 ? '#2691a3' : '#D0ECE6',
                      '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                        backgroundColor:
                          personType.id === 2 ? '#2691a3' : '#D0ECE6',
                      },
                    }}
                    onClick={() => setPersonType({ id: 2, type: 'consultant' })}
                  >
                    A Consultant
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className="mb-4 w-max flex self-end"
                    style={{
                      backgroundColor:
                        personType.id === 3 ? '#2691a3' : '#D0ECE6',
                      color: personType.id === 3 ? '#fff' : '#000',
                    }}
                    sx={{
                      fontSize: '16px',
                      fontWeight: 500,
                      padding: '8px 30px',
                      textTransform: 'capitalize',
                      color: personType.id === 3 ? '#fff' : '#000',
                      backgroundColor:
                        personType.id === 3 ? '#2691a3' : '#D0ECE6',
                      '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                        backgroundColor:
                          personType.id === 3 ? '#2691a3' : '#D0ECE6',
                      },
                    }}
                    onClick={() => setPersonType({ id: 3, type: 'volunteer' })}
                  >
                    A Volunteer
                  </Button>
                </FormGroup>
              </Stack>
            )}
            <div className="create-main-btn">
              <Button
                endIcon={loading && <CircularProgress size={'20px'} />}
                aria-label="ddd"
                disabled={
                  loading ||
                  data?.error ||
                  (survey_id_manage === survey_id && !accept) ||
                  (!(survey_id === REACT_APP_SURVEY_ID_ER) && !personType.id)
                }
                onClick={handleClickNav}
                className="signupCVbtnSign"
                type="submit"
                variant="contained"
                style={{
                  backgroundColor:
                    loading ||
                    (!(survey_id === REACT_APP_SURVEY_ID_ER) &&
                      !personType.id) ||
                    data?.error ||
                    (survey_id_manage === survey_id && !accept)
                      ? '#e0e0e0'
                      : '#2691a3',
                }}
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  padding: '8px 30px',
                  textTransform: 'capitalize',
                  backgroundColor: '#2691a3',
                  '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                    backgroundColor: '#2691a3',
                  },
                }}
              >
                {data?.error ? data?.error : 'Click Here To Start'}
              </Button>
            </div>
          </div>
          <div className="create-bottom">
            {data?.companyLogo ? (
              <div
                className="text-container-bottom-desc"
                style={{
                  justifyContent: !data?.partnerlogo
                    ? 'center'
                    : 'space-between',
                }}
              >
                <div className="text-container-bottom-desc-img">
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/${data?.companyLogo}`}
                    alt=""
                  />
                </div>
                {data?.partnerlogo && (
                  <div className="text-container-bottom-desc-text">
                    In Partnership With
                  </div>
                )}
                {data?.partnerlogo && (
                  <div className="text-container-bottom-desc-img">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/${data?.partnerlogo}`}
                      alt=""
                    />
                  </div>
                )}
              </div>
            ) : (
              <>
                {
                  <div className="text-container-bottom-desc-img kaya-logo">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/${data?.partnerlogo}`}
                      alt=""
                    />
                  </div>
                }
              </>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
